﻿import { IApprovalWorkflow, IApprover } from "@/interfaces";

export const updateDependentApprovers = (
  parentApproverId: string,
  approvalWorkflow: IApprovalWorkflow,
  dependentApprover: IApprover
): void => {
  if (parentApproverId) {
    recursivelyUpdateDependentApprovers(
      approvalWorkflow.approvers,
      dependentApprover,
      parentApproverId
    );

    return;
  }

  approvalWorkflow.approvers = [
    ...approvalWorkflow.approvers,
    dependentApprover,
  ];
};

const recursivelyUpdateDependentApprovers = (
  approvers: IApprover[] = [],
  dependentApprover: IApprover,
  parentApproverId: string
): void => {
  approvers.forEach((approver) => {
    const { id, dependantApprovers } = approver;

    if (id === parentApproverId) {
      approver.dependantApprovers = dependantApprovers
        ? [...dependantApprovers, dependentApprover]
        : [dependentApprover];

      return;
    }

    if (dependantApprovers) {
      recursivelyUpdateDependentApprovers(
        approver.dependantApprovers,
        dependentApprover,
        parentApproverId
      );
    }
  });
};
